/**
 * 页面 URL 参数只在这里解释，渲染与状态机只消费结构化结果。
 * URLSearchParams 会按 application/x-www-form-urlencoded 规则完成一次解码，
 * 因而中文 q 不应再手工 decodeURIComponent，否则会发生二次解码。
 */
export function parseSceneOptions(search = '') {
  const params = new URLSearchParams(search);
  const seed = params.has('seed') ? Number(params.get('seed')) : null;
  const requestedTheme = params.get('theme');
  const requestedPose = params.get('pose');
  const requestedQuality = params.has('quality') ? Number(params.get('quality')) : null;
  const requestedDelegate = params.get('delegate')?.toLowerCase();

  return {
    debug: params.get('debug') === '1',
    cameraDebug: params.get('camdebug') === '1',
    // CPU is the stable default on iOS Safari. GPU remains an explicit test
    // path and has a timed CPU fallback if its creation promise hangs.
    handDelegate: requestedDelegate === 'gpu' ? 'GPU' : 'CPU',
    measure: params.get('measure') === '1',
    mobilePreview: params.get('mobile') === '1',
    measurePose: ['left', 'right'].includes(requestedPose) ? requestedPose : 'rest',
    kiosk: params.get('kiosk') === '1',
    autocam: params.get('autocam') === '1',
    mute: params.get('mute') === '1',
    fullDisplay: params.get('display') === 'full',
    // 正式根地址默认是免费摘要 + 完整报告锁定态。
    // 只有开发、审稿和本地 Kiosk 显式传 report=full 时展示完整内容。
    reportLocked: params.get('report') !== 'full',
    reportDebug: params.get('reportdebug') === '1',
    qualityTier: [0, 1, 2].includes(requestedQuality) ? requestedQuality : null,
    theme: requestedTheme === 'jade' ? 'jade' : 'azure',
    category: params.has('category') ? (params.get('category')?.trim() || null) : null,
    question: params.get('q') || '',
    timeScope: ['none', 'near', 'mid', 'long'].includes(params.get('time'))
      ? params.get('time') : 'none',
    mode: params.get('mode') === 'meihua' ? 'meihua' : 'liuyao',
    measurementSeed: Number.isFinite(seed) ? seed : null
  };
}
